import React, { useState, useEffect, useMemo } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  CircularProgress,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  Grid,
} from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import axios from "../../axios";
import { osmApi } from "../osmApi";

export default function UploadDialog({ open, onClose, onSuccess }) {
  const [file, setFile] = useState(null);

  const [classId, setClassId] = useState("");
  const [sectionId, setSectionId] = useState("");
  const [assessmentId, setAssessmentId] = useState("");
  const [studentId, setStudentId] = useState("");

  const [classArr, setClassArr] = useState([]);
  const [secArr, setSecArr] = useState([]);
  const [assessments, setAssessments] = useState([]);
  const [students, setStudents] = useState([]);

  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  // 🚀 LocalStorage se dynamic IDs nikalna (No Hardcoding)
  const jsonRole_CTinformation = useMemo(
    () => JSON.parse(localStorage.getItem("role_as_class_teacher") || "[]"),
    [],
  );
  const jsonRole_COOinformation = useMemo(
    () => JSON.parse(localStorage.getItem("role_as_co_ordinator") || "[]"),
    [],
  );

  // Ye keys tumhare screenshot ke hisaab se hain
  const teacherId = JSON.parse(localStorage.getItem("Teacher_id") || '""');
  const academicSessionId = JSON.parse(
    localStorage.getItem("academicYearSessionId") || '""',
  );
  const timeTableSessionId = JSON.parse(
    localStorage.getItem("timeTableSessionId") || '""',
  );
  const schoolId = JSON.parse(localStorage.getItem("schoolId") || '""');

  // 1. Class Dropdown
  useEffect(() => {
    let arr1 = [];
    jsonRole_CTinformation.forEach((item) => {
      if (item.is_class_teacher && item.standard_id) {
        if (!arr1.some((obj) => obj.id === item.standard_id.id)) {
          arr1.push({ id: item.standard_id.id, name: item.standard_id.name });
        }
      }
    });
    jsonRole_COOinformation.forEach((item) => {
      if (item.is_class_co_ordinator && item.standard_id) {
        if (!arr1.some((obj) => obj.id === item.standard_id.id)) {
          arr1.push({ id: item.standard_id.id, name: item.standard_id.name });
        }
      }
    });
    setClassArr(arr1);
  }, [jsonRole_CTinformation, jsonRole_COOinformation]);

  // 2. Section Dropdown
  useEffect(() => {
    let arr2 = [];
    if (classId) {
      jsonRole_CTinformation.forEach((item) => {
        if (item?.standard_id?.id === classId && item.section_id) {
          if (!arr2.some((obj) => obj.id === item.section_id.id)) {
            arr2.push({ id: item.section_id.id, name: item.section_id.name });
          }
        }
      });
      jsonRole_COOinformation.forEach((item) => {
        if (item?.standard_id?.id === classId && item.section_id) {
          if (!arr2.some((obj) => obj.id === item.section_id.id)) {
            arr2.push({ id: item.section_id.id, name: item.section_id.name });
          }
        }
      });
    }
    setSecArr(arr2);
  }, [classId, jsonRole_CTinformation, jsonRole_COOinformation]);

  // 3. Fetch Assessments (Dynamic)
  useEffect(() => {
    console.log(
      "fethcih  asesemnt",
      classId,
      " classid",
      "section ",
      sectionId,
      "teacerid",
      teacherId,
      "acdemocsetoms",
      academicSessionId,
      "tescadas,",
      timeTableSessionId,
    );
    if (
      classId &&
      sectionId &&
      teacherId &&
      academicSessionId &&
      timeTableSessionId
    ) {
      axios
        .get(
          `/api/v1/assessment/filterByTeacherId/${teacherId}/review?academicSessionId=${academicSessionId}&timetableSessionId=${timeTableSessionId}`,
        )
        .then((res) => {
          const filtered = (res.data.data || []).filter(
            (a) =>
              a.standard_id?.id === classId && a.section_id?.id === sectionId,
          );
          setAssessments(filtered);
        })
        .catch((err) => console.error("Assessment Error:", err));
    } else {
      setAssessments([]);
    }
  }, [classId, sectionId, teacherId, academicSessionId, timeTableSessionId]);

  // 4. Fetch Students (Dynamic)
  useEffect(() => {
    if (classId && sectionId && schoolId && timeTableSessionId) {
      axios
        .get(`/api/v1/school/student/get/school/${schoolId}`)
        .then((res) => {
          const filtered = (res.data.data || []).filter(
            (s) =>
              s.standard?.id === classId &&
              s.section?.id === sectionId &&
              s.timetableSession?.id === timeTableSessionId,
          );
          setStudents(filtered);
        })
        .catch((err) => console.error("Student Error:", err));
    } else {
      setStudents([]);
    }
  }, [classId, sectionId, schoolId, timeTableSessionId]);

  const handleUpload = async () => {
    if (!file || !studentId || !assessmentId) {
      setError("Please fill all fields and select a PDF.");
      return;
    }
    setBusy(true);
    setError("");

    try {
      const res = await osmApi.uploadScript(file, studentId, assessmentId);
      onSuccess(res);
    } catch (e) {
      setError(
        e.response?.data?.message || "Upload failed. Check your connection.",
      );
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Upload Answer Book</DialogTitle>
      <DialogContent dividers>
        <Box display="flex" flexDirection="column" gap={3} py={1}>
          <Grid container spacing={2}>
            {/* Class Dropdown */}
            <Grid item xs={6}>
              <FormControl fullWidth size="small">
                <InputLabel>Class</InputLabel>
                <Select
                  value={classId}
                  label="Class"
                  onChange={(e) => {
                    setClassId(e.target.value);
                    setSectionId("");
                    setAssessmentId("");
                    setStudentId("");
                  }}
                >
                  {classArr.map((c) => (
                    <MenuItem key={c.id} value={c.id}>
                      {c.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            {/* Section Dropdown */}
            <Grid item xs={6}>
              <FormControl fullWidth size="small" disabled={!classId}>
                <InputLabel>Section</InputLabel>
                <Select
                  value={sectionId}
                  label="Section"
                  onChange={(e) => {
                    setSectionId(e.target.value);
                    setAssessmentId("");
                    setStudentId("");
                  }}
                >
                  {secArr.map((s) => (
                    <MenuItem key={s.id} value={s.id}>
                      {s.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            {/* Assessment Dropdown */}
            <Grid item xs={12}>
              <FormControl fullWidth size="small" disabled={!sectionId}>
                <InputLabel>Assessment / Exam</InputLabel>
                <Select
                  value={assessmentId}
                  label="Assessment / Exam"
                  onChange={(e) => setAssessmentId(e.target.value)}
                >
                  {assessments.length === 0 ? (
                    <MenuItem disabled value="">
                      No assessments found
                    </MenuItem>
                  ) : (
                    assessments.map((a) => (
                      <MenuItem key={a.id} value={a.id}>
                        {a.name} ({a.subject_id?.name})
                      </MenuItem>
                    ))
                  )}
                </Select>
              </FormControl>
            </Grid>

            {/* Student Dropdown */}
            <Grid item xs={12}>
              <FormControl fullWidth size="small" disabled={!assessmentId}>
                <InputLabel>Student</InputLabel>
                <Select
                  value={studentId}
                  label="Student"
                  onChange={(e) => setStudentId(e.target.value)}
                >
                  {students.length === 0 ? (
                    <MenuItem disabled value="">
                      No students found
                    </MenuItem>
                  ) : (
                    students.map((s) => (
                      <MenuItem key={s.id} value={s.id}>
                        {s.name} (Adm: {s.admissionNumber})
                      </MenuItem>
                    ))
                  )}
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          {/* File Upload Box */}
          <Box
            sx={{
              border: "2px dashed #1976d2",
              borderRadius: 2,
              p: 4,
              textAlign: "center",
              bgcolor: "#f3f8ff",
              cursor: "pointer",
            }}
            component="label"
          >
            <input
              type="file"
              accept="application/pdf"
              hidden
              onChange={(e) => setFile(e.target.files[0])}
            />
            <CloudUploadIcon sx={{ fontSize: 48, color: "#1976d2", mb: 1 }} />
            <Typography variant="body1" fontWeight="bold">
              {file ? file.name : "Click to select PDF"}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {file
                ? `${(file.size / 1024 / 1024).toFixed(2)} MB`
                : "Only .pdf files are allowed"}
            </Typography>
          </Box>

          {error && (
            <Typography color="error" variant="caption">
              {error}
            </Typography>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={busy}>
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={handleUpload}
          disabled={!file || !studentId || !assessmentId || busy}
        >
          {busy ? <CircularProgress size={20} /> : "Upload & Start"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
